// extracted by mini-css-extract-plugin
export var body = "styles-module--body--9eeP8";
export var container = "styles-module--container--YRLtW";
export var convenientCare = "styles-module--convenientCare--6--a0";